import styled from "styled-components";
import { Tooltip } from "antd";
import InfoCircle from "@untitled-ui/icons-react/build/esm/InfoCircle";

// #region STYLES
const StyledTooltipStockLevelOverTime = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .stock-level-over-time {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
    }
    .title-1 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .title-1-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .title-1-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011431 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .not-included-as-sales-or-new-stock {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .title-2 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .title-2-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .title-2-span2 {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .frame-1000011438 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011439 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .source-store-pos-stock-movements {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .source-store-pos-stock-movements-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .source-store-pos-stock-movements-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .this-metric-is-period-dependent {
        color: var(--bostagea-blue-outline, #0060cc);
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
`;

const StyledTooltipItemsSold = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .items-sold-count-consumer-sales-only {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        width: 100%;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .titles-span3 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .frame-1000011432 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011431 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .not-counted-as-sales {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .frame-1000011434 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-2-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-3 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-3-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-3-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .this-metric-is-period-dependent {
        color: var(--bostagea-blue-outline, #0060cc);
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
`;

const StyledTooltipReturns = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .returns-count-customer-returned-items {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        width: 100%;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .titles-span4 {
        color: var(--buttons-all-platforms-gray-100, #d1d1d1);
    }
    .frame-1000011432 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011431 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .not-counted-as-returns {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .frame-1000011434 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-2-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011435 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-3 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-3-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-3-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .this-metric-is-period-dependent {
        color: var(--bostagea-blue-outline, #0060cc);
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
`;

const StyledTooltipInStores = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .stores-with-this-item-in-stock {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .stores-with-current-stock-greater-than-zero {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011435 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-2-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
`;

const StyledTooltipTotalSales = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .sales-value {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        width: 100%;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .titles-span3 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-3 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .titles-3-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-3-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .this-metric-is-period-dependent {
        color: var(--bostagea-blue-outline, #0060cc);
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
`;

const StyledTooltipGrossMargin = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .profit-after-item-cost {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011431 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .formula {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-2 {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-2-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-2-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-3-item-cost-data {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-3-item-cost-data-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-3-item-cost-data-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .this-metric-is-period-dependent {
        color: var(--bostagea-blue-outline, #0060cc);
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
`;

const StyledTooltipOverallStock = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .current-sellable-stock {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .sellable-stock-96-items {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011431 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .negative-stock {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-1-item {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-1-item-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-1-item-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-1-item-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011438 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-2-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
`;

const StyledTooltipGeneric = styled.div`
    .styled-tooltip {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 6px;
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        line-height: 14px;
    }
    .divider {
        height: 1px !important;
        background: #4f5b6d;
    }
    .frame-1000011430 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .current-sellable-stock {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 700;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011433 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .sellable-stock-96-items {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .frame-1000011436 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011431 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .negative-stock {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-1-item {
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-1-item-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-1-item-span2 {
        color: var(--text-and-icons-green-500, #00bb00);
    }
    .titles-1-item-span3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .frame-1000011438 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: auto;
        position: relative;
        overflow: visible;
    }
    .frame-1000011437 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .titles-2 {
        text-align: left;
        font-size: 10px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }
    .titles-2-span {
        color: var(--text-and-icons-gray-200, #7c868b);
    }
    .titles-2-span2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
`;
// #endregion

// #region Tooltips
export const TooltipStockLevelOverTime = ({ enabled = false }) => {
    return (
        <Tooltip
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "408px",
                height: "100%"
            }}
            title={
                <StyledTooltipStockLevelOverTime>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="stock-level-over-time">Sales over time</div>
                        </div>
                        <div className="title-1">
                            <span>
                                <span className="title-1-span">
                                    Shows cumulative net items sold during the selected period.
                                    <br />
                                    The final chart value equals Items sold (net).
                                    <br />
                                </span>
                                <span className="title-1-span2">
                                    → Line goes up when items are sold.
                                    <br />
                                    → Line may go down when returns are higher than sales in that period.
                                    <br />
                                </span>
                            </span>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011431">
                            <div className="not-included-as-sales-or-new-stock">Not counted as sales:</div>
                        </div>
                        <div className="title-2">
                            <span>
                                <span className="title-2-span">
                                    → Transfers
                                    <br />
                                    → Stock corrections
                                    <br />
                                    → Reconciliations
                                    <br />
                                    → Sync adjustments
                                    <br />
                                </span>
                            </span>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011439">
                            <div className="source-store-pos-stock-movements">
                                <span>
                                    <span className="source-store-pos-stock-movements-span">Source: </span>
                                    <span className="source-store-pos-stock-movements-span2">
                                        Store POS sales and returns events
                                    </span>
                                </span>
                            </div>
                            <div className="this-metric-is-period-dependent">*this metric is period-dependent</div>
                        </div>
                    </div>
                </StyledTooltipStockLevelOverTime>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipItemsSold = ({ enabled = false, open, data }) => {
    const {
        consumer_sales = "--",
        returns = "--",
        items_sold_net = "--",
        transfers_out = "--",
        transfers_in = "--",
        stock_adjustments = "--",
        sync_adjustments = "--"
    } = data || {};

    return (
        <Tooltip
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "300px",
                height: "100%"
            }}
            open={open}
            title={
                <StyledTooltipItemsSold>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="items-sold-count-consumer-sales-only">Items sold (net)</div>
                        </div>
                        <div className="frame-1000011433">
                            <div className="titles">
                                <div>
                                    <span className="titles-span">Consumer sales: </span>
                                    <span className="titles-span2">
                                        {consumer_sales !== "--" ? `${consumer_sales} items` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span">Consumer returns: </span>
                                    <span className="titles-span2">
                                        {returns !== "--" ? `${returns} items` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span3">Items sold (net): </span>
                                    <span className="titles-span2">
                                        {items_sold_net !== "--" ? `${items_sold_net}` : "--"}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="frame-1000011432 divider" />
                        <div className="frame-1000011431">
                            <div className="not-counted-as-sales">Not counted as sales:</div>
                        </div>
                        <div className="frame-1000011434">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Transfers out: </span>
                                    <span className="titles-2-span2">
                                        {transfers_out !== "--" ? `${transfers_out}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-2-span">Transfers in: </span>
                                    <span className="titles-2-span2">
                                        {transfers_in !== "--" ? `${transfers_in}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-2-span">Stock corrections: </span>
                                    <span className="titles-2-span2">
                                        {stock_adjustments !== "--" ? `${stock_adjustments}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-2-span">Sync adjustments: </span>
                                    <span className="titles-2-span2">
                                        {sync_adjustments !== "--" ? `${sync_adjustments}` : "--"}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-3">
                                <span>
                                    <span className="titles-3-span">Source: </span>
                                    <span className="titles-3-span2">
                                        Store POS sales, returns and stock movements events
                                    </span>
                                </span>
                            </div>
                            <div className="this-metric-is-period-dependent">*this metric is period-dependent</div>
                        </div>
                    </div>
                </StyledTooltipItemsSold>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipReturns = ({ enabled = false, open, data }) => {
    const {
        returned_transactions = "--",
        returned_items = "--",
        return_value = "--",
        transfers_in = "--",
        stock_adjustments = "--",
        sync_adjustments = "--"
    } = data || {};

    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "265px",
                height: "100%"
            }}
            title={
                <StyledTooltipReturns>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="returns-count-customer-returned-items">Returns</div>
                        </div>
                        <div className="frame-1000011430">
                            <div className="returns-count-customer-returned-items" style={{ fontWeight: "400" }}>
                                Counts customer-returned item.
                            </div>
                        </div>
                        <div className="frame-1000011433">
                            <div className="titles">
                                <span>
                                    <span className="titles-span">Returned transactions: </span>
                                    <span className="titles-span2"></span>
                                    <span className="titles-span3">
                                        {returned_transactions !== "--" ? `${returned_transactions}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span2">
                                        Returned items: {returned_items !== "--" ? `${returned_items}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span">Return value: </span>
                                    <span className="titles-span2"></span>
                                    <span className="titles-span4">
                                        {return_value !== "--" ? `${return_value}` : "--"}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="frame-1000011432 divider" />
                        <div className="frame-1000011431">
                            <div className="not-counted-as-returns">Not counted as returns:</div>
                        </div>
                        <div className="frame-1000011434">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Transfers in: </span>
                                    <span className="titles-2-span2">
                                        {transfers_in !== "--" ? `${transfers_in}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-2-span">Stock corrections: </span>
                                    <span className="titles-2-span2">
                                        {stock_adjustments !== "--" ? `${stock_adjustments}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-2-span">Sync adjustments: </span>
                                    <span className="titles-2-span2">
                                        {sync_adjustments !== "--" ? `${sync_adjustments}` : "--"}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011435">
                            <div className="titles-3">
                                <span>
                                    <span className="titles-3-span">Source: </span>
                                    <span className="titles-3-span2">Store POS return and stock movement events</span>
                                </span>
                            </div>
                            <div className="this-metric-is-period-dependent">*this metric is period-dependent</div>
                        </div>
                    </div>
                </StyledTooltipReturns>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipInStores = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "235px",
                height: "100%"
            }}
            title={
                <StyledTooltipInStores>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="stores-with-this-item-in-stock">Stores with this item in stock</div>
                        </div>
                        <div className="frame-1000011433">
                            <div className="stores-with-current-stock-greater-than-zero">
                                Stores with current sellable stock greater than zero.
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011435">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">Store POS current stock/on-hand data</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipInStores>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipTotalSales = ({ enabled = false, open, data }) => {
    const { gross_sales = "--", returns = "--", discounts = "--", total_sales = "--" } = data || {};

    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "255px",
                height: "100%"
            }}
            title={
                <StyledTooltipTotalSales>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="sales-value">Sales value</div>
                        </div>
                        <div className="frame-1000011433">
                            <div className="titles">
                                <span>
                                    <span className="titles-span">Gross sales: </span>
                                    <span className="titles-span2">
                                        {gross_sales !== "--" ? `${gross_sales}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span">Returns: </span>
                                    <span className="titles-span2">
                                        {returns !== "--" ? `${returns}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span">Discounts: </span>
                                    <span className="titles-span2">
                                        {discounts !== "--" ? `${discounts}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span3">
                                        Total sales: {total_sales !== "--" ? `${total_sales}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span">VAT/Tax: </span>
                                    <span className="titles-span2">included</span>
                                </span>
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-3">
                                <span>
                                    <span className="titles-3-span">Source: </span>
                                    <span className="titles-3-span2">Store POS sales, returns and discount events</span>
                                </span>
                            </div>
                            <div className="this-metric-is-period-dependent">*this metric is period-dependent</div>
                        </div>
                    </div>
                </StyledTooltipTotalSales>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipGrossMargin = ({ enabled = false, open, data }) => {
    const { total_sales = "--", item_cost = "--", gross_margin = "--", gross_margin_pct = "--" } = data || {};

    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "335px",
                height: "100%"
            }}
            title={
                <StyledTooltipGrossMargin>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="profit-after-item-cost">Profit after item cost</div>
                        </div>
                        <div className="frame-1000011433">
                            <div className="titles">
                                <span>
                                    <span className="titles-span">Total sales: </span>
                                    <span className="titles-span2"></span>
                                    <span className="titles-span3">
                                        {total_sales !== "--" ? `${total_sales}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span">Item cost: </span>
                                    <span className="titles-span2"></span>
                                    <span className="titles-span3">
                                        {item_cost !== "--" ? `${item_cost}` : "--"}
                                        <br />
                                    </span>
                                    <span className="titles-span2">
                                        Gross margin: {gross_margin !== "--" ? `${gross_margin}` : "--"}
                                        <br />
                                        Gross margin (%):{" "}
                                        {gross_margin_pct !== "--" && gross_margin_pct !== null
                                            ? `${gross_margin_pct}`
                                            : "--"}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011431">
                            <div className="formula">Formula: </div>
                        </div>
                        <div className="titles-2">
                            <span>
                                <span className="titles-2-span">Gross margin: </span>
                                <span className="titles-2-span2"></span>
                                <span className="titles-2-span3">
                                    Total sales - Item cost
                                    <br />
                                </span>
                                <span className="titles-2-span">Gross margin %: </span>
                                <span className="titles-2-span2"></span>
                                <span className="titles-2-span3">Gross margin/Total sales</span>
                            </span>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-3-item-cost-data">
                                <span>
                                    <span className="titles-3-item-cost-data-span">Source: </span>
                                    <span className="titles-3-item-cost-data-span2">
                                        Store POS sales, returns and discount events + item cost data
                                    </span>
                                </span>
                            </div>
                            <div className="this-metric-is-period-dependent">*this metric is period-dependent</div>
                        </div>
                    </div>
                </StyledTooltipGrossMargin>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipOverallStock = ({ enabled = false, open, data }) => {
    const { sellable_stock = "--", negative_stock = "--" } = data || {};

    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "245px",
                height: "100%"
            }}
            title={
                <StyledTooltipOverallStock>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">Current sellable stock</div>
                        </div>
                        <div className="frame-1000011433">
                            <div className="sellable-stock-96-items">
                                Sellable stock: {sellable_stock !== "--" ? `${sellable_stock} items` : "--"}
                            </div>
                        </div>
                        <div className="frame-1000011436 divider" />
                        <div className="frame-1000011431">
                            <div className="negative-stock">Negative stock</div>
                        </div>
                        <div className="titles-1-item">
                            <span>
                                <span className="titles-1-item-span">Excluded from sellable stock: </span>
                                <span className="titles-1-item-span2"></span>
                                <span className="titles-1-item-span3">
                                    {negative_stock !== "--" ? `${negative_stock} items` : "--"}
                                </span>
                            </span>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">Store POS current stock/on-hand data</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipOverallStock>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipSellThroughRate = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "265px",
                height: "100%"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">Sell-through rate (current)</div>
                        </div>
                        <div className="titles-1-item">
                            <span className="titles-3-item-span">
                                Sales speed in units per day for the selected scope.
                                <br />
                                This metric is calculated from the Max period and does not change when a shorter period
                                is selected.{" "}
                            </span>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">
                                        Store POS current sales event + exposure data
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipOutOfStockInDays = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "405px",
                height: "100%"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">Out of stock in</div>
                        </div>
                        <div className="titles-1-item">
                            <div className="titles-3-item-span">
                                Shows how many calendar days are left until the selected item or variation is no longer
                                available in the selected scope.
                                <br />
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                For one variation in one store:
                                <br />
                                current stock / current sales rate.
                                <br />
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                For item or multiple-store views:
                                <br />
                                based on when the last available variation/store path runs out.
                                <br />
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                If stock exists but there is no current sales rate, the timing cannot be estimated.{" "}
                                <span className="text-orange">
                                    These variations are excluded from the item level calculation.
                                </span>
                                <br />
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                This metric is calculated from the Max period and does not change when a shorter period
                                is selected.
                            </div>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">
                                        Store POS current sales event + current stock/on-hand data
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipAcceleration = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "center",
                width: "405px",
                height: "100%"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">Acceleration</div>
                        </div>
                        <div className="titles-1-item">
                            <div className="titles-3-item-span">
                                Compares sales speed in the last 14 days with the previous 14 days.
                                <br />
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                Rising: faster sales
                                <br />
                                Idle: no meaningful change
                                <br />
                                Dimming: slower sales
                                <br />
                                Low confidence means there were too few recent sales to make the trend reliable.
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                This metric is calculated from the Max period and does not change when a shorter period
                                is selected.
                            </div>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">Store POS sales events</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipShelfSpeed = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "left",
                width: "405px",
                height: "100%",
                left: "20%",
                transform: "translateX(-20%)"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">Shelf Speed</div>
                        </div>
                        <div className="titles-1-item">
                            <div className="titles-3-item-span">
                                Overall movement label based on sales rate, stock cover, and recent acceleration.
                                <br />
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                Fast mover: strong sales speed
                                <br />
                                Watch List: monitor closely
                                <br />
                                Slow mover: weak movement or too much stock cover
                            </div>
                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                This metric is calculated from the Max period and does not change when a shorter period
                                is selected.
                            </div>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">
                                        Store POS sales events + current stock/on-hands data
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipPercentageOut = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "left",
                width: "270px",
                height: "100%",
                left: "20%",
                transform: "translateX(-20%)"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">% Out</div>
                        </div>
                        <div className="titles-1-item">
                            <div className="titles-3-item-span">
                                Share of received sellable stock that has been sold to customers.
                            </div>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">Store POS sales events + stock/on-hands data</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipWSStock = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "left",
                width: "270px",
                height: "100%",
                left: "20%",
                transform: "translateX(-20%)"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">WS Stock</div>
                        </div>
                        <div className="titles-1-item">
                            <div className="titles-3-item-span">
                                Supplier‑side stock available for order or reorder.
                            </div>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="titles-2-span">Source: </span>
                                    <span className="titles-2-span2">Store POS sales events + stock/on-hands data</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle className={`info-circle ${enabled ? "text-white" : "text-inactive"}`} />
        </Tooltip>
    );
};

export const TooltipExposureDays = ({ enabled = false, open }) => {
    return (
        <Tooltip
            open={open}
            color="#10141b"
            overlayInnerStyle={{
                textAlign: "left",
                width: "250px",
                height: "100%",
                left: "20%",
                transform: "translateX(-20%)"
            }}
            title={
                <StyledTooltipGeneric>
                    <div className="styled-tooltip">
                        <div className="frame-1000011430">
                            <div className="current-sellable-stock">Exposure days</div>
                        </div>
                        <div className="titles-1-item">
                            <div className="titles-3-item-span">
                                Calendar days this item or variation had sellable stock in the selected scope during the
                                selected period.
                            </div>

                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                At item level, exposure counts days when at least one variation was in stock.
                            </div>

                            <div className="titles-3-item-span" style={{ marginTop: "10px" }}>
                                “--” means there is not enough stock history to calculate exposure.
                            </div>
                        </div>
                        <div className="frame-1000011438 divider" />
                        <div className="frame-1000011437">
                            <div className="titles-2">
                                <span>
                                    <span className="text-blue-600">*this metric is period-dependent</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </StyledTooltipGeneric>
            }>
            <InfoCircle
                className={`info-circle  align-self-center mr-4px ${enabled ? "text-white" : "text-inactive"}`}
            />
        </Tooltip>
    );
};
// #endregion
